import { render, staticRenderFns } from "./FormDialog.vue?vue&type=template&id=00d10d74"
import script from "./FormDialog.vue?vue&type=script&lang=js"
export * from "./FormDialog.vue?vue&type=script&lang=js"
import style0 from "./FormDialog.vue?vue&type=style&index=0&id=00d10d74&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports